import React, { useEffect, useState } from "react";
import SlideoverModal from "src/components/SlideoverModal";
import ReactSelect from "react-select";
import Button from "src/base-components/Button";
import Card from "src/components/Card";
import {
  clearUpdateCall,
  customerInfo,
  queueCalls,
  selectCustomerInfo,
  selectUpdateCall,
  updateCallLog,
} from "src/stores/calllogs";
import { useAppDispatch, useAppSelector } from "src/stores";
import Lucide from "src/base-components/Lucide";
import { SelectOption } from "src/interfaces";
import { clearCallLogsToasts } from "src/stores/callLogsToasts/slice";
import { callTypeOptions } from "src/components/CallsLogsModal/constants";
import LoadingIcon from "src/base-components/LoadingIcon";

interface Props {
  visible: boolean;
  onClose: () => void;
  direction: string | null;
  getCallerNum?: string | null;
  getSessionID: string | null;
}

const PostCallRemarks: React.FC<Props> = ({
  visible,
  onClose,
  getCallerNum,
  direction,
  getSessionID,
}) => {
  const [callType, setCallType] = useState<SelectOption | null>(null);
  const [getSelectedQueryID, setGetSelectQueryID] = useState("");
  
  const [queryError, setQueryError] = useState("");
  const [notesErr, setNotesErr] = useState("");
  const [notes, setNotes] = useState("");
  const dispatch = useAppDispatch();
  const { loading, data } = useAppSelector(selectUpdateCall);

  // Clear stale updateCall state from previous submissions on open
  useEffect(() => {
    if (visible) {
      dispatch(clearUpdateCall());
    }
  }, [visible, dispatch]);

  // const callTypeOptions = [
  //   { value: "support", label: "Support" },
  //   { value: "booking", label: "Booking" },
  //   { value: "inquiry", label: "Inquiry" },
  //   { value: "complaint", label: "Complaint" },
  // ];

  useEffect(() => {
    if (!getCallerNum) return;
    if (getCallerNum) {
      dispatch(customerInfo(getCallerNum));
    }
  }, [getCallerNum]);
  // Prefill notes from local cache saved during query creation
  useEffect(() => {
    if (!getSessionID) return;
    try {
      const cached = localStorage.getItem(`callRemarks_${getSessionID}`);
      if (cached && cached.trim().length > 0 && !notes) {
        setNotes(cached);
      }
    } catch (e) {
      // ignore storage errors
    }
  }, [getSessionID]);
  // Also try prefill from cached call detail payload
  useEffect(() => {
    if (!getSessionID) return;
    if (notes && notes.trim().length > 0) return;
    try {
      const detail = localStorage.getItem(`callDetail_${getSessionID}`);
      if (detail) {
        const parsed = JSON.parse(detail);
        const apiRemarks = parsed?.call?.remarks;
        if (typeof apiRemarks === "string" && apiRemarks.trim().length > 0) {
          setNotes(apiRemarks);
        }
      }
    } catch (e) {
      // ignore parse/storage errors
    }
  }, [getSessionID]);
  const getCustomerInfo = useAppSelector(selectCustomerInfo);
  const InfoCustomer = getCustomerInfo?.data?.result?.customer;
  const queriesInfo = getCustomerInfo?.data?.result?.queries;


  console.log(queriesInfo , "getCustomerInfo" );
  

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setQueryError("");
    setNotesErr("");

    if (!getSessionID) return;

    // ❌ Removed query selection validation

    if (!notes) {
      setNotesErr("Please enter remarks");
      return;
    }

    try {
      let payload: any = {
        customer_id: InfoCustomer?.customer_id ?? "",
        query_id: getSelectedQueryID ?? "", // optional now
        remarks: notes,
        call_type: "Answered",
        call_outcome: "",
        queue: 0,
        is_new_query: null,
      };

      dispatch(updateCallLog(getSessionID, payload));
    } catch (error) {
      console.log("PostCallRemarks", error);
    }
  };

  useEffect(() => {
    if (data?.success === true) {
      onClose();
      dispatch(clearUpdateCall());
      dispatch(clearCallLogsToasts());
      dispatch(queueCalls());
      setGetSelectQueryID("");
      setNotes("");
      setCallType(null);
      // Clear cached remarks after successful update
      if (getSessionID) {
        localStorage.removeItem(`callRemarks_${getSessionID}`);
      }
    }
  }, [data?.success]);

  return (
    <SlideoverModal
      visible={visible}
      onClose={() => onClose()}
      headerTitle="Post-Call Remarks"
      size="md"
      backdrop={false}
    >
      {/* <form className="space-y-6" onSubmit={handleSubmit}> */}
      {getCustomerInfo.loading ? (
        <div className=" text-slate-600 w-10 h-10  flex items-center justify-center mx-auto mt-30">
          <LoadingIcon />
        </div>
      ) : (
        <div className="space-y-6">
          <div className="border-2 rounded-xl p-3 hover:bg-slate-50">
            <div className="flex justify-between items-center">
              <div className="flex items-center gap-2">
                <div className="rounded-full w-11 h-11 flex items-center justify-center bg-slate-100">
                  <Lucide
                    icon={
                      direction === "Outbound"
                        ? "PhoneOutgoing"
                        : "PhoneIncoming"
                    }
                  />
                </div>
                <p className="font-medium text-slate-900">
                  {InfoCustomer?.fullname ?? "New Customer"}
                </p>
              </div>
              <p className="text-[#0A0A0A] text-sm border border-[#0A0A0A10] py-0.5 px-2 rounded-lg">
                {direction === "Outbound" ? "outgoing" : "incoming"}
              </p>
            </div>
            <div>
              <div className="text-sm text-slate-500 py-2">
                {/* {InfoCustomer?.country_code && InfoCustomer?.phone
                  ? `${InfoCustomer.country_code}${InfoCustomer.phone}`
                  : "--"} */}
              </div>
              <div className="text-sm text-slate-500 py-2">
                {(getCallerNum && getCallerNum) ?? "--"}
              </div>

              {/* <div className="text-sm text-slate-500 ">
              {formatTime(item.event_time)}
            </div> */}
              {/* <div className="text-sm text-slate-500">
                              {item.time}
                            </div> */}
              {/* {item.queryId && (
                              <div className="mt-2 text-xs text-blue-600">
                                Linked to {item.queryId}
                              </div>
                            )} */}
            </div>
          </div>
          {queriesInfo && queriesInfo?.length > 0 && (
            <div
              className={`flex flex-col gap-6 max-h-[320px]  ${
                queriesInfo && queriesInfo?.length > 2 && "overflow-y-auto pr-2"
              }`}
            >
              {queriesInfo &&
                queriesInfo.length > 0 &&
                queriesInfo?.map((query) => {
                  const total =
                    (Number(query?.no_of_adults) || 0) +
                    (Number(query?.no_of_infants) || 0) +
                    (Number(query?.no_of_children) || 0);

                  return (
                    <Card
                      className={`p-3 cursor-pointer transition-all ${
                        getSelectedQueryID === query.id
                          ? "border-blue-500 bg-blue-50"
                          : "border-gray-200 hover:border-gray-300"
                      }`}
                      onClick={() => {
                        setGetSelectQueryID(query.id);
                        setQueryError("");
                      }}
                      key={query.id}
                    >
                      <div>
                        <div className="flex justify-between items-center">
                          <h4 className=" text-[#075985] text-sm">
                            {query?.query_no}
                          </h4>
                          <div className="flex items-center justify-between gap-x-2">
                            <p className="px-2 py-1 bg-blue-100 text-blue-800 rounded text-xs">
                              {query?.status_text}
                            </p>
                            <p className="px-2 py-1 bg-blue-100 text-blue-800 rounded text-xs">
                              {query?.payment_status}
                            </p>
                          </div>
                        </div>
                        <div className="mt-3">
                          <h4>{InfoCustomer?.fullname}</h4>
                          <div className="flex justify-between items-center mt-1">
                            <p className="text-[10px] text-[#475569]">
                              Customer ID: {InfoCustomer?.customer_id}
                            </p>
                            <p className="text-[10px] text-[#475569]">
                              No. of PAX: {total ?? "-"}
                            </p>
                          </div>
                        </div>
                      </div>
                    </Card>
                  );
                })}
              {queryError && (
                <p className="text-red-500 text-sm mt-1">{queryError}</p>
              )}
            </div>
          )}
          {/* <div className="space-y-2">
            <label className="block font-medium text-slate-900">
              Call Type *
            </label>
            <ReactSelect
              options={callTypeOptions}
              placeholder="Support"
              value={callTypeOptions.find((o) => o.value === callType)}
              onChange={(_, value) => setCallType((value as any)?.value || "")}
            />
            <ReactSelect
              options={callTypeOptions}
              value={
                callTypeOptions.find((o) => o.value === callType?.value) || null
              }
              onChange={(selected) => setCallType(selected)}
              placeholder="Support"
            />
          </div> */}

          <div className="space-y-2">
            <label className="block font-medium text-slate-900">
              Call Notes & Remarks{" "}
              <span className="text-slate-500">(minimum 10 characters)</span>
            </label>
            <textarea
              className="w-full p-3 border border-gray-200 rounded-lg h-28 resize-none focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Provide detailed notes about the call, customer concerns, actions taken, and any follow-up required..."
              value={notes}
              onChange={(e) => {
                setNotes(e.target.value);
                setNotesErr("");
              }}
              minLength={10}
              required={true}
            />
            {notesErr && (
              <p className="text-red-500 text-sm mt-1">{notesErr}</p>
            )}
          </div>

          <div className="flex space-x-3">
            <Button
              type="button"
              variant="outline-secondary"
              className="flex-1 py-3"
              onClick={() => {
                onClose();
                setGetSelectQueryID("");
                setNotes("");
                setCallType(null);
              }}
            >
              Skip For Now
            </Button>
            <Button
              disabled={loading}
              type="button"
              variant="primary"
              className="flex-1 py-3 bg-blue-600 hover:bg-blue-700"
              onClick={handleSubmit}
            >
              {loading ? "Updating..." : "Update & Close"}
            </Button>
          </div>
        </div>
      )}
    </SlideoverModal>
  );
};

export default PostCallRemarks;
